<template>
    <div>
        <div class="newOne">
            <div class="content">
                <h2>纸搬客入驻彩虹园等社区</h2>
                <p class="p-1"><span class="span-1">纸搬客</span>2020年7月24号</p>
                <div class="details">
                    <!-- <img src="../../assets/img/newTwo/1.png" alt="" class="img-2"> -->
                    <p class="p-1 p-spe">经过两个多月的努力，纸搬客在京打造纸类垃圾回收的区域布局又有新突破。近日，纸搬客成功入驻了彩虹园、密西花园和季庄小区，随后还将陆续进驻梧桐苑、果园等多个社区。至此，纸搬客在密云与十几个小区建立了合作关系，以密云为核心的区域布局初步形成。酷暑难耐，纸搬客带着满满的环保之心为密云的垃圾分类贡献一份微薄之力！</p>
                    <img src="../../assets/img/newSix/1.png" alt="" class="img-2">
                    <!-- <p class="p-1">在“世界地球日”当天，纸搬客入驻社区-南华里社区受邀接受来自“首都财经频道”的记者采访</p> -->
                    <p class="p-1 p-spe">2020年初，纸搬客进驻长安小区和世纪家园后便遭遇了新冠疫情的爆发。但是很快就凭借着全程无接触式的智能回收新模式，受到了社区居民的认可和欢迎，废纸回收量连续增长，这也给纸搬客率先布局密云带来了更大的信心。
                    </p>
                    <img src="../../assets/img/newSix/2.png" alt="" class="img-2">
                    <!-- <p class="p-3">（左：南华里物业经理杨玉全      右：纸搬客创始人兼CEO李嘉轩”）</p> -->
                    <p class="p-1 p-spe">作为北京远郊的一个重要辖区，密云的影响力不可小觑，很多外省市的朋友都是通过密云和纸搬客产生了亲密接触，包括希望布局到自己小区的热情居民，以及希望和纸搬客产生良好合作的朋友等等。通过纸搬客在密云的持续发力，可以预见纸搬客的影响力会越来越大，同时，我们也希望外地的朋友可以和纸搬客智能废纸回收机早日见面。
                    </p>
                    <img src="../../assets/img/newSix/3.png" alt="" class="img-2">
                    <!-- <p class="p-3 p-bottom">（左：纸搬客用户“陈大妈”        右：纸搬客用户“郭大爷”）</p> -->
                </div>
            </div>
            <!-- footer -->
            <footer_s></footer_s>
        </div>
    </div>
</template>
<script>
    import footer_s from '../common/footer'
    export default {
        components: {
            footer_s
        },
    }
</script>
<style scoped>
    .newOne {
        width: 100%;
        min-height: 4.4rem;
        position: absolute;
        background-color: #fff;
        top: 0rem;
        left: 0;
        z-index: 100;
    }
    .content{
        width: 60%;
        min-height: 4.4rem;
        margin: 0 auto;
        padding: 0 5%;
    }
    .content h2 {
        font-size: 0.13rem;
        font-family: PingFang SC;
        font-weight: bold;
        color: rgba(14, 14, 14, 1);
        line-height: 0.2rem;
        margin-top: 0.1rem;
    }
    .span-1{
        font-size: 0.06rem;
        margin-right: 0.03rem;
        color: #576b95;
    }
    .p-1 {
        font-size: 0.048rem;
        font-family: PingFang SC;
        font-weight: 500;
        color: #444;
        line-height: 0.1rem;
        margin-top: 0.03rem;
    }
    .details{
        width: 100%;
    }
    .p-2{
        font-size:0.04rem;
        font-family:PingFang SC;
        font-weight:500;
        color: #444;
        line-height:0.1rem;
        margin-bottom: 0.05rem;
    }
    .p-spe{
        text-indent: 2em;
    }
    .img-2{
        width: 100%;
        height: 100%;
        margin-top: 0.07rem;
    }
    .p-3{
        color: rgb(136, 136, 136);
        text-align: center;
        font-size: 0.04rem;
    }
    .p-bottom{
        margin-bottom: 0.3rem;
    }
</style>


// WEBPACK FOOTER //
// src/views/newChild/newSix.vue